import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import AppInsightsTracker from "components/Shared/AppInsightsTracker";
import Select from "react-select";
import { ReactLargeSelectClassName } from "components/Shared/MSelect";
import Creatable from "react-select/creatable";

const changeStatusActions = [
  { label: "Re-open order for 1004p", value: "Re-open order for 1004p" },
  { label: "Update case as ready to assign to Appraiser", value: "Update case as ready to assign to Appraiser" },
  { label: "Re-open case that was Cancelled Pre-Inspection", value: "reopencancelledpreinspection" },
  { label: "Re-open case that was Closed Post Inspection", value: "reopenclosedpostinspection" },
];

class ChangeStatus extends AppInsightsTracker {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      controlNumber: 0,
      action: ""
    };
  }

  submit() {
    const { controlNumber, action } = this.state;
    const { changeStatus } = this.props;
    changeStatus(Number(controlNumber.value), action);
  }

  handleChange = (newValue) => {
    this.setValue(newValue);
  }

  handleInputChange = () => {};

  setValue = (value) => {
    this.setState({
      controlNumber: value
    });
  }

  render() {
    const { action } = this.state;
    return (
      <div className="md-grid md-cell block-card-wrapper">
        <div className="block-card">
          <Card className="card-unnested">
            <CardContent><Typography variant="h6">Change Case Status</Typography></CardContent>
            <CardContent>
              <Creatable
                className={ReactLargeSelectClassName}
                isMulti={false}
                isClearable
                onChange={this.handleChange}
                onInputChange={this.handleInputChange}
                isValidNewOption={inputValue => {
                  return !isNaN(inputValue) && inputValue > 0;
                }}
                placeholder="Control #"
                classNamePrefix="react-select"
              />
              <br />
              <Select
                className={ReactLargeSelectClassName}
                isMulti={false}
                onChange={input => {
                  this.setState({
                    action: input.value
                  });
                }}
                options={changeStatusActions}
                placeholder="Select Action"
                simpleValue
                value={this.state.statesValue}
                removeSelected={true}
                classNamePrefix="react-select"
              />
              <br />
              <Button
                className="full-width m-t-10"
                disabled={!action}
                onClick={this.submit}
              >
                Submit
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }
}

ChangeStatus.propTypes = {
  changeStatus: PropTypes.func.isRequired,
  statusItems: PropTypes.object.isRequired,
  fetchingHeader: PropTypes.bool.isRequired,
};

export default ChangeStatus;